import type {UsersMeClipsResponse} from '../../entities/clip/schema';
import {clipsEntity} from '../../entities/validateClips';

// Clipsのデータから、clipTypeに一致しているものだけを抽出する
export function filterByClipType(
  clips?: UsersMeClipsResponse['clips'],
  type?: string,
): UsersMeClipsResponse['clips'] {
  const reconstructClips = clipsEntity(clips);
  const typesArray = type ? type.split(',') : [];
  return typesArray.length > 0
    ? reconstructClips.filter((clip) => typesArray.includes(clip.type))
    : reconstructClips;
}
